<template>
  <div>
    <SoDialog v-model="value" :card-title="title">
      <SoSimpleTable
        :headers="headers"
        :items="[items]"
        :copy-to-clipboard-fields="filterCopyFields"
        is-pivoted
      >
        <template #tableContent>
          <SoLink
            class="ml-4 mt-4"
            data-testid="feedback-button"
            @click="$emit('click')"
          >
            See More
          </SoLink>
        </template>
      </SoSimpleTable>
    </SoDialog>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import { IhdDetails } from "@/models/ihdDetails/ihdDetails"
  import SoSimpleTable from "@/components/SoSimpleTable.vue"
  import SoLink from "@/components/SoLink.vue"
  import dayjs from "dayjs"

  export default defineComponent({
    components: {
      SoDialog,
      SoSimpleTable,
      SoLink,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      ihd: {
        type: Object as PropType<IhdDetails>,
        default: () => ({}),
      },
      title: {
        type: String,
        default: null,
      },
    },
    emits: ["update:modelValue", "click"],
    data() {
      return {
        headers: [
          "Manufacturer",
          "Model",
          "SMETS version",
          "Firmware status",
          "Firmware version",
          "MPAN",
          "Electricity SSD",
          "MPRN",
          "Gas SSD",
          "Data Last Updated",
        ],
        copyFields: ["Manufacturer", "Model", "Firmware version"],
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value) {
          this.$emit("update:modelValue", value)
        },
      },
      items() {
        const {
          manufacturerFullName,
          manufacturerCode,
          modelName,
          model,
          smetsVersion,
          firmwareStatus,
          firmwareVersion,
          elecSsd,
          mprn,
          gasSsd,
          mpan,
          dateLastUpdated,
        } = this.ihd
        return [
          `${manufacturerFullName || "Unknown"} - ${manufacturerCode}`,
          `${modelName || "Unknown"} - ${model}`,
          `${smetsVersion || "N/A"}`,
          `${firmwareStatus || "N/A"}`,
          `${firmwareVersion || "N/A"}`,
          `${mpan || "N/A"}`,
          elecSsd ? dayjs(elecSsd).format("DD MMM YYYY") : "N/A",
          `${mprn || "N/A"}`,
          gasSsd ? dayjs(gasSsd).format("DD MMM YYYY") : "N/A",
          dateLastUpdated
            ? dayjs(dateLastUpdated).format("DD MMM YYYY HH:mm")
            : "N/A",
        ]
      },
      filterCopyFields() {
        return this.copyFields.filter(
          (field) => this.items[this.headers.indexOf(field)] !== "N/A",
        )
      },
    },
  })
</script>
